import { createGamecloudheaderInstances, GamecloudheaderUI } from "./gamecloudheaderUI";
import { IActivateCheck } from "../../interface";
import { Gamecloud } from "../../gamecloud";
import Axios from "axios";
import { Dialog } from '../../../dialog/dialog';
import { publish } from '../../../../shared/eventbus/eventbus';
import { Events } from '../../../../shared/eventbus/events';

class Gamecloudheader extends Gamecloud {
  public constructor(private ui: GamecloudheaderUI) {
    super();
    this.ui.onActivateButtonClick((button) => this.activateGamecloud('Are you sure you want to activate this gamecloud?', button));
    this.ui.onReactivateButtonClick((button) => this.activateGamecloud('Are you sure you want to reactivate this gamecloud?', button));
  }

  private checkActivatePossibility() {
    return new Promise((resolve, reject) => {
      const url = window.location.href + "/activateCheck/" + this.ui.orderid;
      Axios.post(url, {},{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then((response) => {
        const data: IActivateCheck = response.data;
        resolve(data);
      });
    })
  }

  private activateGamecloud(text: string, button) {
    this.ui.setButtonLoading(true, button);
    this.checkActivatePossibility().then((data: IActivateCheck) => {
      this.ui.setButtonLoading(false, button);
      if (data.check) {
        new Dialog()
          .withTitle('Are you sure?')
          .withText(text)
          .withConfirmButtonText('Activate')
          .withCenteredContent()
          .withOnConfirm(() => {
            window.location.href = window.basePath + window.regionPrefix + '/activateOrder/' + this.ui.orderid;
          })
          .withIcon()
          .render();
      } else {

        new Dialog()
          .withTitle('Not enough credit')
          .withText('Please recharge your account.')
          .withConfirmButtonText('Recharge')
          .withCenteredContent()
          .withOnConfirm(() => {
            publish(Events.OpenRechargeModal, { amount: data.price });
            // window.initRechargeModal(data.price);
          })
          .withIcon('money-bill-wave')
          .render();
      }
    });
  }
}

function initChargebeePortalButtons() {
  $(document).on('click', '[data-chargebee-portal]', function (e) {
    e.preventDefault();
    const $btn = $(this);
    $btn.addClass('loading');

    Axios.get(`${window.regionPrefix}/order/payment_api/chargebeeManagementUrl`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((response) => {
        if (!response.data?.url) {
          throw new Error();
        }
        window.open(response.data.url, '_blank', 'noopener,noreferrer');
      })
      .catch(() => {
        new Dialog()
          .withTitle('Error')
          .withText('Could not open the subscription management portal. Please try again later.')
          .withCenteredContent()
          .withIcon()
          .render();
      })
      .finally(() => {
        $btn.removeClass('loading');
      });
  });
}

export function initGamecloudheader() {
  initChargebeePortalButtons();
  return createGamecloudheaderInstances().map((ui: GamecloudheaderUI) => {
    return new Gamecloudheader(ui);
  });
}
